import React from 'react';
import { ToolSubmenu } from './ToolSubmenu';
import { sceneBackgroundSwatch } from '../../Utils/sceneBackground';

const ToolBtn = ({ active, title, onClick, children, layout }) => (
  <button
    type="button"
    title={title}
    onClick={onClick}
    className={`h-7 px-2 m-0 inline-flex items-center gap-1.5 rounded-sm border text-[10px] font-semibold uppercase tracking-wider transition-colors shrink-0 ${
      layout === 'column' ? 'w-full justify-start' : ''
    } ${
      active
        ? 'border-yellow-400 bg-yellow-500 text-black'
        : 'border-yellow-600/30 bg-zinc-950 text-yellow-400 hover:border-yellow-400 hover:bg-zinc-900'
    }`}
  >
    {children}
  </button>
);

export default function PreferencesStrip({
  open,
  layout = 'column',
  onClose,
  showBgPicker,
  onToggleBgPicker,
  sceneBgColor,
  showLookPicker,
  onToggleLookPicker,
  submenuLayout = 'column',
  onToggleSubmenuLayout,
  showSceneData,
  onToggleSceneData,
  hideLayoutToggle = false,
}) {
  if (!open) return null;

  const display = sceneBackgroundSwatch(sceneBgColor);

  return (
    <ToolSubmenu layout={layout} label="Preferences" onClose={onClose}>
      <ToolBtn
        layout={layout}
        title="Scene background colour"
        active={showBgPicker || !!sceneBgColor}
        onClick={onToggleBgPicker}
      >
        <span
          className="block h-3.5 w-3.5 rounded-full border border-yellow-500/50 shrink-0"
          style={{ background: display }}
        />
        <span className={layout === 'column' ? 'inline' : 'hidden sm:inline'}>Background</span>
      </ToolBtn>

      <ToolBtn
        layout={layout}
        title="Studio lighting look"
        active={showLookPicker}
        onClick={onToggleLookPicker}
      >
        <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="1.7">
          <circle cx="12" cy="12" r="3.5" />
          <path d="M12 4v2M12 18v2M4 12h2M18 12h2M6.5 6.5l1.4 1.4M16.1 16.1l1.4 1.4M6.5 17.5l1.4-1.4M16.1 7.9l1.4-1.4" strokeLinecap="round" />
        </svg>
        <span className={layout === 'column' ? 'inline' : 'hidden sm:inline'}>Studio</span>
      </ToolBtn>

      {!hideLayoutToggle && (
        <ToolBtn
          layout={layout}
          title={
            submenuLayout === 'column'
              ? 'Submenus: column on right (click for top row)'
              : 'Submenus: row on top (click for right column)'
          }
          active={submenuLayout === 'column'}
          onClick={onToggleSubmenuLayout}
        >
          {submenuLayout === 'column' ? (
            <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="1.7">
              <rect x="14" y="4" width="6" height="16" rx="1" />
              <path d="M4 8h8M4 12h8M4 16h8" strokeLinecap="round" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="1.7">
              <rect x="4" y="4" width="16" height="5" rx="1" />
              <path d="M4 14h16M4 18h16" strokeLinecap="round" />
            </svg>
          )}
          <span className={layout === 'column' ? 'inline' : 'hidden sm:inline'}>
            {submenuLayout === 'column' ? 'Side' : 'Top'}
          </span>
        </ToolBtn>
      )}

      <ToolBtn
        layout={layout}
        title="Scene data: FPS, GPU, memory, and per-model cost"
        active={showSceneData}
        onClick={onToggleSceneData}
      >
        <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="1.7">
          <path d="M4 18V10M10 18V6M16 18v-7M22 18H2" strokeLinecap="round" />
        </svg>
        <span className={layout === 'column' ? 'inline' : 'hidden sm:inline'}>Scene data</span>
      </ToolBtn>
    </ToolSubmenu>
  );
}
